import service from '@/services/item-group/ItemGroupService'

export const itemGroupModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    itemGroupList: [],
    itemGroup: {},
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
    headerList: [],
  },
  mutations: {
    SETITEMGROUPLIST(state, payload) {
      state.itemGroupList = payload.data ?? payload
      state.pagination.current_page = payload.current_page
      state.pagination.last_page = payload.last_page
      state.headerList = []
    },
    SETITEMGROUP(state, payload) {
      state.itemGroup = payload.data ?? payload
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },

  actions: {
    async getItemsGroup({ commit }, payload) {
      try {
        commit('SET_LOADING')
        const response = await service.getGroups(payload)
        commit('SETITEMGROUPLIST', response)
      } finally {
        commit('SET_LOADING')
      }
    },
    async getItemGroup({ commit }, payload) {
      try {
        commit('SET_LOADING')
        const response = await service.getItemGroup(payload)
        commit('SETITEMGROUP', response)
        return response
      } finally {
        commit('SET_LOADING')
      }
    },
    async updateItemGroup({ commit, dispatch, state }, payload) {
      try {
        const form = { ...payload.form }
        commit('SET_LOADING')
        const { status } = await service.update(form, payload.id)

        dispatch('getItemsGroup', { page: state.pagination.current_page })

        return status
      } finally {
        commit('SET_LOADING')
      }
    },
    async insertItemGroup({ commit, dispatch, state }, payload) {
      try {
        commit('SET_LOADING')
        const { status } = await service.insert(payload)

        dispatch('getItemsGroup', { page: state.pagination.current_page })
        return status
      } finally {
        commit('SET_LOADING')
      }
    },
    async deleteItemGroup({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)
      dispatch('getItemsGroup', { page: state.pagination.current_page })
      return status
    },

    /* Obtém um código de grupo ao incluir novo grupo */
    async createItemGroup() {
      const retorno = await service.createItemGroup()
      return retorno
    },
  },

  getters: {
    getComboBoxList: (state) => {
      let comboBox = state.itemGroupList.map((group) => {
        return {
          text: group.DESCRICAO,
          value: group.CODIGO,
        }
      })
      return comboBox
    },
  },
}
